import { Component, Input } from '@angular/core';
import { Result } from '@ca/core/models';
import { ResultsService, UserNotificationService } from '@ca/core/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EMPTY } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { DESCRIPTION_LENGTH_LIMIT, TITLE_LENGTH_LIMIT } from '../../constants/form-validators';

@Component({
    selector: 'ca-result-editor',
    templateUrl: './result-editor.component.html',
    styleUrls: ['./result-editor.component.scss'],
})
export class ResultEditorComponent {
    @Input() showDescription: boolean = true;
    isSubmitting: boolean = false;
    data = { id: '', title: '', description: '' };
    titleLengthLimit: number = TITLE_LENGTH_LIMIT;
    descriptionLengthLimit: number = DESCRIPTION_LENGTH_LIMIT;

    constructor(
        private resultService: ResultsService,
        private userNotificationService: UserNotificationService,
        private activeModal: NgbActiveModal,
    ) {}

    dismiss(reason?: string): void {
        this.activeModal.dismiss(reason);
    }

    submit(): void {
        const { id, title, description } = this.data;

        this.isSubmitting = true;
        this.userNotificationService.showSpinner();

        this.resultService
            .updateResult$(id, description, title.trim())
            .pipe(
                tap((result: Result) => {
                    if (result.title != null) {
                        this.data.title = result.title;
                    }
                    if (result.description != null) {
                        this.data.description = result.description;
                    }

                    this.userNotificationService.showSuccess('GENERAL.CHANGED_SUCCESS');

                    this.activeModal.close(this.data);
                }),
                catchError((err: unknown) => {
                    this.userNotificationService.showError('GENERAL.CHANGED_FAILURE');
                    console.error("'Failed to save result changes", err);
                    return EMPTY;
                }),
                finalize(() => {
                    this.isSubmitting = false;
                    this.userNotificationService.hideSpinner();
                }),
            )
            .subscribe();
    }
}
